export const Svg_085 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
    <defs>
      <linearGradient
        id="a"
        x1={30}
        x2={8.9}
        y1={13}
        y2={43.1}
        data-name="Gradiente sem nome"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={57.1}
        x2={41.3}
        y1={16.3}
        y2={38.8}
        data-name="Gradiente sem nome 2"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={42.1}
        x2={28.1}
        y1={36.1}
        y2={56}
        data-name="Gradiente sem nome 3"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
    </defs>
    <path
      d="M31.5 49.8c-.2-.8-.9-1.5-1.8-1.6L27 38.1c0-.2-.2-.4-.4-.5l-3.2-1.9c-.7-.4-1.6-.5-2.4-.3l-2.3-9.1c-.4-1.5-2-2.4-3.5-2h-.3c-1.3.4-2.2 1.6-2.1 2.9l.3 10.5c0 1.2.4 2.5 1 3.6l3.7 6.7.8 3.2c-.7.5-1 1.4-.8 2.3l1.5 5.7c.1.5.6.8 1.1.7l12-3.1c.5-.1.8-.6.6-1.1L31.5 50Zm-15.9-9.6c-.5-.8-.7-1.8-.7-2.7L14.6 27c0-.5.3-.9.8-1h.3c.6-.2 1.1.1 1.3.7l2.5 9.6c-.1.1-.2.3-.3.4-.9 1.5-.4 3.4 1.1 4.3l2.4 1.4c.4.3 1 .1 1.3-.3s.1-1-.3-1.3l-2.4-1.4c-.6-.4-.9-1.2-.5-1.8.4-.6 1.2-.9 1.8-.5l2.9 1.7 2.5 9.6-7.7 2-.8-3.1v-.2l-3.7-6.8Zm5.1 17.4-1.2-4.8c0-.2 0-.4.3-.5l9.5-2.5H29.6l.2.2 1.2 4.8-10.2 2.6Z"
      style={{
        fill: "url(#a)",
      }}
    />
    <path
      d="M55.2 24.2h-.3c-1.5-.5-3.1.5-3.5 2l-2.3 9.1c-.8-.2-1.7-.1-2.4.3l-3.2 1.9c-.2.1-.4.3-.4.5l-2.7 10.1c-.9.1-1.5.8-1.8 1.6l-1.5 5.7c-.1.5.2 1 .7 1.1l12 3.1c.5.1 1-.2 1.1-.7l1.5-5.7c.2-.8 0-1.7-.8-2.3l.8-3.2 3.7-6.7c.6-1.1.9-2.3 1-3.6l.3-10.5c0-1.3-.8-2.5-2.1-2.9Zm-4.6 28.7-1.2 4.8-10.2-2.6 1.2-4.8c0-.2.3-.3.5-.3l9.5 2.5c.2 0 .3.3.3.5Zm4.6-15.4c0 1-.3 1.9-.7 2.7L50.8 47v.2l-.8 3.1-7.7-2 2.5-9.6 2.9-1.7c.6-.4 1.5-.2 1.8.5s.2 1.5-.5 1.8l-2.4 1.4c-.4.2-.6.8-.4 1.2.2.4.8.6 1.2.4l2.4-1.4c1.5-.9 2-2.8 1.1-4.3 0-.1-.2-.3-.3-.4l2.5-9.6c.1-.5.7-.9 1.3-.7h.3c.5.2.8.6.8 1.1l-.3 10.5Z"
      style={{
        fill: "url(#b)",
      }}
    />
    <path
      d="M45.8 32.1c2.4-2.8 3.5-6.4 2.9-10v-.2c0-.2-.2-.4-.5-.5H48c-2.5-.4-5.1 0-7.4 1.1.2-.9.2-1.8.2-2.7-.2-3.6-2.1-7-5.1-9.2h-1.1c-3 2.2-4.8 5.5-5.1 9.2 0 .9 0 1.8.2 2.7-2.3-1.1-5-1.6-7.5-1.2h-.1c-.1 0-.2 0-.3.2 0 0-.1 0-.1.1V21.9c-.6 3.6.5 7.3 2.9 10.1 2.4 2.5 5.7 3.9 9.1 3.8.5 0 1.1 0 1.6-.1.5 0 1.1.1 1.6.1 3.4 0 6.8-1.3 9.1-3.8Zm1.2-9c.3 2.9-.7 5.7-2.5 7.9-1.9 2-4.5 3.2-7.2 3.2l4.6-4.6c.3-.4.3-.9 0-1.3s-.9-.4-1.3 0l-4.4 4.5V32c.2-2.4 1.4-4.6 3.1-6.3 2.2-1.9 5-2.8 7.9-2.5Zm-15.7-3.2c.2-2.9 1.6-5.5 3.8-7.3 2.2 1.8 3.6 4.5 3.8 7.3 0 1.4-.2 2.9-.7 4.2 0 0-.2.1-.2.2-.7.7-1.4 1.4-1.9 2.3v-5.8c0-.5-.4-.9-.9-.9s-.9.4-.9.9v5.8c-.5-.9-1.2-1.6-1.9-2.3-.6-1.4-.9-2.8-.8-4.3Zm-8.2 3.2c2.9-.3 5.7.6 7.9 2.5 1.8 1.6 2.9 3.9 3.1 6.3v.8l-4.4-4.5c-.4-.4-.9-.4-1.3 0s-.4.9 0 1.3l4.6 4.6c-2.8 0-5.4-1.2-7.2-3.2-1.9-2.2-2.8-5-2.5-7.9Z"
      style={{
        fill: "url(#c)",
      }}
    />
  </svg>
)